import { useTranslation } from 'react-i18next';

import { notify } from '@speeki/global-ui-components';

import { ChatRoomFilesUploadDocument } from '@graphql/generated/graphql';

import { useMutation } from '@apollo/client';

export const useChatRoomUploadFiles = () => {
    const { t } = useTranslation();

    const [fileUploadMutation] = useMutation(ChatRoomFilesUploadDocument, {
        onError: () => notify(t('WRONG_CHAT_FILE_TYPE')).ERROR(),
    });

    const fileUpload = async (
        data: {
            chatRoomRefUuid: string;
            file: {
                name: string;
                size: number;
                type: string;
                uri: string;
            };
            firebaseToken?: string;
        },
        callback?: (progress: number) => void,
    ) => {
        const { chatRoomRefUuid, file, firebaseToken } = data;

        const response = await fileUploadMutation({
            context: {
                fetchOptions: {
                    onProgress: (event: ProgressEvent) => {
                        callback?.((event.loaded / event.total) * 100);
                    },
                    useUpload: true,
                },
                firebaseToken,
            },
            variables: {
                filesInput: {
                    chatRoomRefUuid: chatRoomRefUuid,
                    uploads: [
                        {
                            file: file,
                            fileKey: file.name,
                        },
                    ],
                },
            },
        });

        // FIXME: error handling
        // eslint-disable-next-line @typescript-eslint/only-throw-error
        if (response.errors) throw response.errors;

        if (!response.data) throw new Error('Data is null');

        return response.data.chatRoomFilesUpload[0];
    };

    return { fileUpload };
};
